import { createFileRoute } from '@tanstack/react-router'
import * as v from 'valibot'

import CertificatePoll from '@/certificate/components/CertificatePoll'

const pollSearchSchema = v.object({
  step: v.fallback(v.optional(v.number()), 1),
})

export const Route = createFileRoute(
  '/_learning/_my-learning/certificate/$certificateId/poll',
)({
  validateSearch: pollSearchSchema,
  component: RouteComponent,
})

function RouteComponent() {
  const certificateId = Route.useParams({ select: (p) => p.certificateId })
  const step = Route.useSearch({ select: (s) => s.step })

  return <CertificatePoll certificateId={certificateId} step={step} />
}
